import { MenuItem } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getStatusBadgeClass } from './action-items-table-utils';

const STATUS_OPTIONS = ['pending', 'in_progress', 'completed', 'overdue'] as const;

interface StatusDropdownContentProps {
  onSelect: (status: string) => void;
  /** Currently selected status, highlighted in the list (individual edit context). */
  selectedStatus?: string;
}

/**
 * Shared status dropdown content rendered in both individual and bulk edit contexts.
 * Ensures consistent UI/UX across the application.
 */
export const StatusDropdownContent: FC<StatusDropdownContentProps> = ({
  onSelect,
  selectedStatus,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {STATUS_OPTIONS.map((status) => (
        <MenuItem
          key={status}
          selected={status === selectedStatus}
          onClick={() => onSelect(status)}
          className="hover:bg-gray-100"
        >
          <span
            className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeClass(status)}`}
          >
            {t(`meeting-secretary.action-items.status-${status.replace(/_/g, '-')}`)}
          </span>
        </MenuItem>
      ))}
    </>
  );
};

export { STATUS_OPTIONS };
